// src/components/CartButton.jsx
import React from 'react';
import useCartStore from '../store/cartStore';

const CartButton = () => {
  const toggleCart = useCartStore((state) => state.toggleCart);

  return (
    <img
      src="/images/shoppingcart.svg"
      alt="Cart"
      className="w-6 h-6 cursor-pointer"
      onClick={() => {
        toggleCart();
      }}
    />
  );
};

export default CartButton;
